import React from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  HeaderFilter,
  ColumnFixing,
  Scrolling
} from "devextreme-react/data-grid";
let errorsDetailGrid = React.createRef();
let accessToken = '';
class WMTransactionsPrintErrors extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
        const today = new Date();
        this.state = {
            records: 0,
            rundate: `${today.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            })} ${today.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })}`,
            reportname: props.reportname,
            reportformat: props.reportformat
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-2">
                        Run: {this.state.rundate.toString()}
                        <br />
                        From: {this.state.reportname}
                    </div>
                    <div className="col-md-8 text-center">
                        <h6><strong>Demo Database</strong></h6>
                        <h5><strong>AB Application Error Log</strong></h5>
                        <h6>{this.state.reportformat}</h6>
                    </div>
                </div>
                <div className="row">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        showBorders={true}
                        ref={errorsDetailGrid}
                        dataSource={this.props.dataSource}
                        className="customDataTableDesign"
                        hoverStateEnabled={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        height="500px"
                        showRowLines={true}
                    //onContentReady={this.DetailInGridContentReady}
                    >
                         <Scrolling mode="virtual" useNative={false} />    
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <ColumnFixing enabled={true} />
                        <ColumnHeaderFilter />
                        <Export enabled={true} allowExportSelectedData={true} text="Export" />
                        <Sorting visible={true} mode="multiple" />
                        <LoadPanel enabled={true} />
                        <Paging defaultPageSize={100} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={false} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        {/*<StateStoring
                enabled={true}
                type="custom"
                customLoad={detailInGridLoadState}
                storageKey={detailInGridKey}
                customSave={detailInGridSaveState}
            />*/}

                        <Column
                            dataField="sourceFrom"
                            caption="Source From"
                            allowEditing={false}
                        ></Column>
                        <Column
                            dataField="creationDateTime"
                            caption="Creation Date"
                            dataType="date"
                            allowEditing={false}
                        ></Column>
                        <Column
                            dataField="creationUserId"
                            caption="Created By"
                            allowEditing={false}
                        ></Column>
                        {/* <Column
                            dataField="transactiontype"
                            caption="Type"
                            allowEditing={false}
                        ></Column> */}
                        <Column
                            dataField="sourceTableName"
                            caption="Source Table"
                            allowEditing={false}
                        ></Column>
                        {/* <Column
                            dataField="invoicedate"
                            caption="Invoice Date"
                            allowEditing={false}
                        ></Column> */}
                        <Column
                            dataField="description"
                            caption="Description"
                            allowEditing={false}
                        ></Column>
                        <Column
                            dataField="transactionNumber"
                            caption="Transaction #"
                            allowEditing={false}
                        ></Column>
                    </DataGrid>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMTransactionsPrintErrors);